import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #f8f2ff;
  padding: 60px 0 30px;
  color: #6a1b9a;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  margin-bottom: 20px;
`;

const FooterLogo = styled.div`
  margin-bottom: 15px;
  
  img {
    height: 60px;
  }
`;

const FooterTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 15px;
  color: #6a1b9a;
`;

const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
`;

const SocialLink = styled.a`
  color: #6a1b9a;
  font-size: 20px;
  transition: color 0.3s;
  
  &:hover {
    color: #9c27b0;
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLinkItem = styled.li`
  margin-bottom: 10px;
`;

const FooterLink = styled(Link)`
  color: #6a1b9a;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  
  &:hover {
    color: #9c27b0;
  }
`;

const ContactInfo = styled.div`
  margin-top: 15px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  font-size: 12px;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <FooterLogo>
            <Link to="/">
              <img src="/logo-placeholder.png" alt="Ateliê Dentinhos de Leite" />
            </Link>
          </FooterLogo>
          <FooterText>
            No Ateliê Dentinhos de Leite, o sorriso dos pequenos é nossa prioridade!
          </FooterText>
          <SocialLinks>
            <SocialLink href="#" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </SocialLink>
            <SocialLink href="#" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </SocialLink>
            <SocialLink href="#" aria-label="WhatsApp">
              <i className="fab fa-whatsapp"></i>
            </SocialLink>
          </SocialLinks>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Links Úteis</FooterTitle>
          <FooterLinks>
            <FooterLinkItem><FooterLink to="/especialidades">Especialidades</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/estrutura">Estrutura</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/depoimentos">Depoimentos</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/quem-somos">Quem Somos</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/nossa-equipe">Nossa Equipe</FooterLink></FooterLinkItem>
            <FooterLinkItem><FooterLink to="/contato">Contato</FooterLink></FooterLinkItem>
          </FooterLinks>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Institucional</FooterTitle>
          <FooterText>
            Ateliê Dentinhos de Leite | Odontopediatria
          </FooterText>
          <ContactInfo>
            <ContactItem>
              <i className="fas fa-map-marker-alt" style={{ marginRight: '8px' }}></i>
              R. Exemplo, 123 - Bairro, Cidade - Estado
            </ContactItem>
            <ContactItem>
              <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
              (00) 00000-0000
            </ContactItem>
          </ContactInfo>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Horário de Atendimento</FooterTitle>
          <FooterText>
            <strong>Segunda a Sexta:</strong> 8h às 17h
          </FooterText>
          <FooterText>
            <strong>Sábado:</strong> Fechado
          </FooterText>
          <FooterText>
            <strong>Domingo:</strong> Fechado
          </FooterText>
        </FooterColumn>
      </FooterContent>
      
      <Copyright>
        <FooterText>
          © {new Date().getFullYear()} Ateliê Dentinhos de Leite - Todos os direitos reservados
        </FooterText>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
